import { apiSlice } from "../api/apiSlice";

export const videoApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getVideo: builder.query({
			query: (videoId) => `/videos/${videoId}`,
		}),
		getVideos: builder.query({
			query: () => "/videos",
		}),
		editVideo: builder.mutation({
			query: ({ id, data }) => ({
				url: `/videos/${id}`,
				method: "PUT",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const result = await queryFulfilled;

				if (result?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getVideos",
							undefined,
							(draft) => {
								let indexToUpdate = draft.findIndex(
									(video) => video.id == arg.id
								);
								if (indexToUpdate !== -1) {
									draft[indexToUpdate] = result.data;
								}
							}
						)
					);

					dispatch(
						apiSlice.util.updateQueryData(
							"getVideo",
							arg.id.toString(),
							(draft) => {
								Object.assign(draft, result.data);
							}
						)
					);
				}
			},
		}),
		deleteVideo: builder.mutation({
			query: (id) => ({
				url: `/videos/${id}`,
				method: "DELETE",
			}),
			async onQueryStarted(id, { queryFulfilled, dispatch }) {
				// delete optismatically
				const patchResult = dispatch(
					apiSlice.util.updateQueryData(
						"getVideos",
						undefined,
						(draft) => {
							const indexToDelete = draft.findIndex(
								(video) => video.id == id
							);
							if (indexToDelete !== -1) {
								draft.splice(indexToDelete, 1);
							}
						}
					)
				);

				try {
					await queryFulfilled;
				} catch (error) {
					patchResult.undo();
				}
			},
		}),
		addVideo: builder.mutation({
			query: (data) => ({
				url: "/videos",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const result = await queryFulfilled;

				if (result?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getVideos",
							undefined,
							(draft) => {
								draft.push(result.data);
							}
						)
					);
				}
			},
		}),
	}),
});

export const { 
	useGetVideoQuery, 
	useGetVideosQuery, 
	useEditVideoMutation,
	useDeleteVideoMutation,
	useAddVideoMutation
} = videoApi;
